import { fetchApi } from "../../config/fetchConfig";
import { buildRequestBody, alias } from "../../utils";
import { setLocale } from "./localeAction";
const DEFAULT_PAGE_SIZE = 24;

const fetchStart = (queries, locale) => ({
    type: "FETCH_QUERIES_START",
    payload: queries,
    locale,
});

const fetchSuccess = (data, queries, locale) => ({
    type: "FETCH_QUERIES_SUCCESS",
    locale,
    payload: {
        data,
        queries,
    },
});

const fetchReject = (queries, locale) => ({
    type: "FETCH_QUERIES_REJECT",
    locale,
    payload: queries,
});

let controller;
export const fetchAction =
    (queries = [], forceRefresh, notCancelable) =>
    (dispatch, getState) => {
        const { fetch: fetchReducer, locale } = getState();

        const currentUrl = window.location.pathname;
        const urlLocaleMatch = currentUrl.match(/^\/([a-z]{2,})\//);
        if (urlLocaleMatch && urlLocaleMatch[1] !== locale) {
            const urlLocale = urlLocaleMatch[1];
            dispatch(setLocale(urlLocale));
            const updatedState = getState();
            return fetchAction(
                queries,
                forceRefresh,
                notCancelable,
            )(dispatch, () => ({
                ...updatedState,
                locale: urlLocale,
            }));
        }

            if (controller && controller.abort) {
                controller.abort();
            }
            const queriesStatus = fetchReducer.status;
            const now = Date.now();

            const outdatedQueries = [];
            const uptodateQueries = [];
            queries.forEach((query) => {
                const isDatagridReq = query.isDatagridReq;
                const statusKey = alias(
                    {
                        ...query,
                        locale,
                    },
                    true,
                    null,
                    isDatagridReq,
                );

                const status = queriesStatus[statusKey] || { lastReadTime: now };

                const queryPage = (query.args || {}).page;
                const queryPageSize = (query.args || {}).pageSize;
                const querySort = (query.args || {}).sort;
                const pagging = [queryPage || 0, queryPageSize];
                const statusPagging = status.pagging || [];
                const statusSort = status.sort || [];

                const samePage =
                    queryPage !== undefined ? pagging[0] === Math.abs(statusPagging[0]) : true;

                const samePageSize =
                    queryPageSize !== undefined ? pagging[1] === Math.abs(statusPagging[1]) : true;

                const sameSort = querySort !== undefined ? querySort === statusSort : true;

                let append;
                if (isDatagridReq !== true) {
                    append = status.pagging && (pagging[0] || 0) > (status.pagging[0] || 0);
                }

                let page = pagging[0];
                let pageSize = pagging[1];
                if (!status.pagging && pagging[0] > 0 && isDatagridReq !== true) {
                    page = 0;
                    pageSize =
                        queryPageSize > 0
                            ? (pagging[0] + 1) * queryPageSize
                            : (pagging[0] + 1) * DEFAULT_PAGE_SIZE;
                    append = false;
                }

                if (!forceRefresh && samePage && samePageSize && sameSort && status.success) {
                    const readDiff = (now - (status.lastReadTime || 0)) / 1000 / 60;

                    if (readDiff < 5 && !query.forceRefresh) {
                        // 5 minutes cache
                        uptodateQueries.push({
                            ...query,
                            append: false,
                        });
                        return null;
                    }
                }
                if (pagging[0] !== undefined) {
                    const statusPage = (status.pagging || [])[0] || 0;
                    const pageDiff = pagging[0] - statusPage;

                    if (pageDiff > 1 && isDatagridReq !== true) {
                        page = 0;
                        pageSize = (pagging[0] + 1) * DEFAULT_PAGE_SIZE;
                        append = false;
                    }
                }
                if (outdatedQueries.findIndex(({ key }) => key === statusKey) < 0) {
                    outdatedQueries.push({
                        ...query,
                        args: {
                            ...(query.args || {}),
                            page: (query.args || {}).page !== undefined ? page : undefined,
                            pageSize,
                            sort: querySort,
                        },
                        append,
                        key: statusKey,
                    });
                }
            });
            const queriesBody = buildRequestBody(outdatedQueries, locale);
            if (queriesBody) {
                dispatch(fetchStart(outdatedQueries, locale));
                controller = notCancelable ? null : new AbortController();
                const signal = controller && controller.signal;
                return fetchApi(
                    "/graphql",
                    queriesBody,
                    { signal },
                    { dispatch, user: getState()?.user, locale },
                )
                    .then((res) => res.json().catch(() => ({})))
                    .then((res) => {
                        controller = null;
                        const data = res.data || {};
                        dispatch(fetchSuccess(data, [...uptodateQueries, ...outdatedQueries], locale));
                    })
                    .catch((e) => {
                        controller = null;
                        dispatch(fetchReject(queries, locale));
                    });
            }
        };
